// CalendarInput.js
import React, { useState, useRef, useEffect } from "react";

const CalendarInput = ({
  value,
  onChange,
  min,
  max,
  className = "",
  placeholder = "Select date",
  disabled = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const inputRef = useRef(null);

  const toggleCalendar = (e) => {
    e.preventDefault();
    
    if (isOpen) {
      // If calendar is already open, blur to close it
      e.target.blur();
      setIsOpen(false);
    } else {
      // If calendar is closed, open it
      e.target.showPicker();
      setIsOpen(true);
    }
  };

  const handleBlur = () => {
    setTimeout(() => {
      setIsOpen(false);
    }, 200);
  };

  const handleChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <div className="relative">
      <input
        ref={inputRef}
        type="date"
        value={value}
        onChange={handleChange}
        min={min}
        max={max}
        disabled={disabled}
        className={`w-full px-3 py-2 text-sm border border-gray-300 rounded-md cursor-pointer ${className} ${
          disabled ? "bg-gray-100 cursor-not-allowed" : "bg-white"
        }`}
        onClick={toggleCalendar}
        onBlur={handleBlur}
        placeholder={placeholder}
      />
    </div>
  );
};

export default CalendarInput;